import "./PulpPaperTissueCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import Casestudydeepdive from "./sections/Casestudydeepdive";
import Footer from "@/reusable_sections/Footer";
export default function PulpPaperTissueCaseStudyPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <Casestudydeepdive />
      <Footer />
    </div>;
}